import useInfiniteFeedRow from '@cont/SWRInfiniteFeedRow/useInfiniteFeedRow';
import { getFeedAPI } from '@api/fetchers/free-platform';

const useEntireFeed = ({ goalUID, limit = 3 }) =>
  useInfiniteFeedRow({
    initialURL: getFeedAPI({ goalUID, limit }),
    swrOptions: {
      revalidateOnMount: false,
      revalidateFirstPage: false
    }
  });

export default useEntireFeed;
